import { AppShellContent, Stack, Text, Title } from "@assetwatch/ui";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useVisiblePages } from "../lib/pageAccess";
import { pagePath } from "../pages/types";

/**
 * The landing page. Deliberately thin — it lists the pages the signed-in user
 * can reach and nothing else. Each page is gated by its own flag, so a page
 * that's off is simply absent here, the same as in the nav.
 */
function MlFrontendHomeRoute() {
  const pages = useVisiblePages();

  return (
    <AppShellContent
      pageHeader={
        <Stack gap={8}>
          <Title size="lg">ML Frontend</Title>
          <Text tone="subtle">
            Internal tools with love from the AssetWatch Data Science team.{" "}
            <span aria-hidden="true" className="text-negative">
              ♥
            </span>
          </Text>
        </Stack>
      }
    >
      <Stack gap={16}>
        {pages.length === 0 ? (
          <Text tone="subtle">No pages are enabled for your account yet.</Text>
        ) : (
          pages.map((page) => (
            <Stack gap={4} key={page.id}>
              <Link to={pagePath(page)}>{page.title}</Link>
              <Text size="sm" tone="subtle">
                {page.description}
              </Text>
            </Stack>
          ))
        )}
      </Stack>
    </AppShellContent>
  );
}

export const Route = createFileRoute("/_app/")({
  component: MlFrontendHomeRoute,
});
